import React from "react";
import { classNames } from "../../helpers/classNames";

const Radio = ({
  radioName,
  radioInputClass,
  isChecked,
  radioLabel,
  radioLableClass,
  value,
  className,
  onChange = () => { },
  id,
  ...props
}) => {
  return (
    <label htmlFor={id} className="block">
      <div
        className={classNames(
          "relative overflow-hidden flex items-center",
          className
        )}
      >
        <input
          type="radio"
          name={radioName}
          className={
            "peer absolute top-1 left-0 w-5 h-5 opacity-0 z-10 cursor-pointer " +
            radioInputClass
          }
          checked={isChecked}
          onChange={onChange}
          value={value}
          id={id}
        />
        <div className="w-5 h-5 min-w-[20px] border border-md-pink-light-1 rounded-full flex items-center justify-center text-[10px] bg-md-pink-light-2 text-black/0 peer-checked:bg-white peer-checked:border-md-pink peer-checked:text-md-pink">
          <i className="fa-solid fa-fw fa-circle"></i>
        </div>
        {radioLabel && (
          <div
            className={
              "text-base text-md-dark w-full font-medium ml-3 pb-1 " +
              radioLableClass
            }
          >
            {radioLabel}
          </div>
        )}
      </div>
    </label>
  );
};

export default Radio;
